// Shared cancellation source for outgoing axios requests.
// `installInflightInterceptor()` registers a one-time request interceptor that
// attaches the current source's CancelToken to every axios call (unless the
// caller already supplied its own cancelToken/signal). When the app needs to
// abort everything in flight — e.g. before a role/context switch that will
// invalidate the current auth token server-side — call
// `abortInFlightRequests()`. That cancels all pending requests and immediately
// installs a fresh source so subsequent requests pick up a new token.

import axios from 'axios';

let currentSource = axios.CancelToken.source();
let installed = false;

export function getInflightCancelToken() {
  return currentSource.token;
}

export function abortInFlightRequests(reason = 'aborted') {
  try {
    currentSource.cancel(reason);
  } catch (e) {
    // ignore
  }
  currentSource = axios.CancelToken.source();
}

export function installInflightInterceptor() {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    if (config && !config.cancelToken && !config.signal) {
      config.cancelToken = currentSource.token;
    }
    return config;
  });
}
